import { tv } from 'tailwind-variants'
import { cn } from '@scalis/utils'
import { ButtonIconKind } from './button-icon.types'

export const buttonIcon = tv({
  base: 'flex items-center justify-center transition-colors focus:outline-hidden disabled:opacity-50 cursor-pointer disabled:cursor-not-allowed',
  variants: {
    rounded: {
      true: 'rounded-md',
      false: 'rounded-none',
    },
    size: {
      small: 'h-6 w-6',
      medium: 'h-8 w-8',
      large: 'h-10 w-10',
    },
    kind: {
      [ButtonIconKind.primary]: cn(
        'hover:bg-neutral-30',
        'active:bg-neutral-40',
        'enabled:hover:bg-neutral-30',
        'enabled:active:bg-neutral-40',
        'disabled:text-neutral-disabled',
      ),
      [ButtonIconKind.orange]: cn(
        'bg-button-orange-rest',
        'hover:bg-button-orange-hover',
        'active:bg-button-orange-pressed',
        'disabled:bg-button-orange-rest disabled:opacity-50',
        'text-dataviz-orange',
      ),
      [ButtonIconKind.brand]: cn(
        'hover:bg-button-brand-primary-light-pressed',
        'active:bg-button-brand-primary-light-pressed',
        'disabled:bg-button-brand-primary-rest disabled:opacity-50',
      ),
      [ButtonIconKind.colored]: cn(
        'transition-colors',
        'group-hover:bg-[var(--hover-color)]',
        'group-active:bg-[var(--active-color)]',
        'disabled:opacity-50',
      ),
    },
    outline: {
      true: 'border border-neutral-00',
      false: '',
    },
    selected: {
      true: 'bg-neutral-30',
      false: '',
    },
  },
  defaultVariants: {
    size: 'medium',
    outline: false,
  },
})
